<template>
  <div>
    <v-container style="width:100% !important;">
      <v-layout wrap>
        <v-flex xs9>
          <h2>
            {{ $t('Order filling options') }}
            <toggle-button
              :value="setShopOption"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="setShopOptionToggle"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </h2>
        </v-flex>
        <v-flex xs3 class="text-xs-right" v-if="setShopOption">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditShopOption"
            @click="isEditShopOption = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <shop-option
        :isEdit="isEditShopOption"
        @onSave="saveShopOption"
        @onReset="resetShopOption"
        :init="shopOption"
        :shopOption="shopOption"
        :setShopOption="setShopOption"
        class="shopOption"
      >
      </shop-option>
    </v-container>
    <v-divider></v-divider>

    <template>
      <v-container style="width:100% !important;">
        <tax-invoice></tax-invoice>
      </v-container>
      <v-divider></v-divider>
    </template>

    <v-container style="width:100% !important;">
      <v-layout wrap>
        <v-flex xs9 style="align-self: center;">
          <h2>{{ $t('Customers can edit their addresses.') }}</h2>
          <span>{{
            $t(
              'If this feature is enabled Customers will be able to check the status or edit the delivery address via chat.'
            )
          }}</span>
        </v-flex>
        <v-flex xs3 class="text-xs-right" style="align-self: center; margin-top: 12px">
          <div>
            <toggle-button
              class="mt-2"
              :value="EditAddress"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="toggleEditAddress"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>

    <v-container style="width:100% !important;">
      <v-layout wrap>
        <v-flex xs9>
          <h2>{{ $t('Additional messages after order summary') }}</h2>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <template v-if="$store.getters.getPackage == 'premium'">
            <v-btn
              fab
              outline
              small
              color="primary"
              v-if="!isEditOrderSummaryMessage"
              @click="isEditOrderSummaryMessage = true"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn readonly fab outline small color="blue" v-on="on">
                  <v-icon>lock</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t(
                  'Upgrade to Premium, starting at 500 baht / month to edit buttons or additional order summary'
                )
              }}</span>
            </v-tooltip>
          </template>
        </v-flex>
      </v-layout>

      <div v-if="wordafter.loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>

      <v-layout wrap v-else>
        <v-flex xs12 sm6 class="border-right pa-1" v-if="wordafter.buttons_cart_summary">
          <view-cart-summary-viewer
            v-model="wordafter.buttons_cart_summary"
            :edit="isEditOrderSummaryMessage"
            :is_hide_add_more_btn="is_hide_add_more_btn"
          ></view-cart-summary-viewer>

          <template v-if="isEditOrderSummaryMessage">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('answer_word_cart_summary') }"
                    >
                      <autoresize-textarea
                        v-if="wordafter.wordscartsummary"
                        maxlength="2000"
                        ref="answer_word_cart_summary"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="wordafter.wordscartsummary.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_word_cart_summary'"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>

                      <div
                        v-if="wordafter.wordscartsummary && wordafter.wordscartsummary.text"
                        shrink
                        class="text-xs-right caption grey--text"
                      >
                        {{ wordafter.wordscartsummary.text.length }}/2000
                      </div>

                      <span class="text-error" v-show="errors.has('answer_word_cart_summary')">{{
                        errors.first('answer_word_cart_summary')
                      }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
            </div>

            <intent-prefill
              @addIntentPrefill="addWordCartSummaryPrefill($event)"
              :payment="true"
            ></intent-prefill>
          </template>
          <template v-else>
            <div
              class="message"
              v-if="
                wordafter.wordscartsummary &&
                  wordafter.wordscartsummary.text != '' &&
                  wordafter.wordscartsummary.type == 'text'
              "
              style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
            >
              <div style="font-size: 12px;" :style="{ color: 'black' }">
                <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
                  <span style="line-height:15.36px; line-height: 22px;">
                    <template
                      v-if="wordafter.wordscartsummary && wordafter.wordscartsummary.text != ''"
                    >
                      <specialtext :text="wordafter.wordscartsummary.text"></specialtext>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <v-divider class="hidden-sm-and-up mb-3"></v-divider>
          <view-receipt-viewer></view-receipt-viewer>
          <div
            v-if="EditAddress"
            class="message"
            style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
          >
            <div style="font-size: 12px;" :style="{ color: 'black' }">
              <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
                <span style="line-height:15.36px;">
                  <template v-if="currentLang == 'th'">
                    📄เลขที่การสั่งซื้อ: 1
                    <br />
                    <br />
                    สามารถตรวจสอบสถานะหรือ แก้ไขที่อยู่ในการจัดส่งได้ที่นี่ 👇
                  </template>
                </span>
              </div>
            </div>
            <div
              style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden"
            >
              <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
                <li
                  class="list-group-item"
                  style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px"
                  v-if="
                    !(
                      !isEditOrderSummaryMessage &&
                      !wordafter.edit_order_buttons[0].labels[currentLang]
                    )
                  "
                >
                  <div
                    class="form-inline form-control d-flex"
                    :class="{ 'has-error': errors.has('editOrderBtn') }"
                    style="align-items: center;"
                    v-if="isEditOrderSummaryMessage"
                  >
                    <input
                      type="text"
                      maxlength="20"
                      class="form-control ma-0"
                      name="editOrderBtn"
                      :placeholder="$t('check_edit')"
                      v-model="wordafter.edit_order_buttons[0].labels[currentLang]"
                      data-vv-name="editOrderBtn"
                      :data-vv-as="$t('check_edit')"
                    />
                    <p class="text-error" v-if="errors.has('editOrderBtn')">
                      {{ errors.first('editOrderBtn') }}
                    </p>
                    <v-btn
                      flat
                      icon
                      class="extra-small ma-0 ml-2"
                      color="primary"
                      @click="wordafter.edit_order_buttons[0].labels[currentLang] = ''"
                    >
                      <i class="fas fa-close"></i>
                    </v-btn>
                  </div>
                  <span style="color: #0084FF" v-else>{{
                    wordafter.edit_order_buttons[0].labels[currentLang]
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
          <template v-if="isEditOrderSummaryMessage">
            <div
              class="message"
              style="float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 8px 6px 2px;background-color:#F1F0F0">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('answer_word_orders') }"
                    >
                      <autoresize-textarea
                        v-if="wordafter.wordsorders"
                        maxlength="2000"
                        ref="answer_word_orders"
                        class
                        :placeholder="$t('Chatbot answers')"
                        v-model="wordafter.wordsorders.text"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_word_orders'"
                        v-validate
                        style="resize: none;display: inherit;margin-bottom: 5px;"
                      ></autoresize-textarea>
                      <div
                        v-if="wordafter.wordsorders && wordafter.wordsorders.text"
                        shrink
                        class="text-xs-right caption grey--text"
                      >
                        {{ wordafter.wordsorders.text.length }}/2000
                      </div>

                      <span class="text-error" v-show="errors.has('answer_word_orders')">{{
                        errors.first('answer_word_orders')
                      }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="clearfix"></div>
            </div>

            <!-- <intent-prefill @addIntentPrefill="addWordOrderPrefill($event)"></intent-prefill> -->
          </template>
          <template v-else>
            <div
              class="message"
              v-if="
                wordafter.wordsorders &&
                  wordafter.wordsorders.text != '' &&
                  wordafter.wordsorders.type == 'text'
              "
              style="float:left;position:relative;border-radius: 12px;max-width: 100%;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
            >
              <div style="font-size: 12px;" :style="{ color: 'black' }">
                <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
                  <span style="line-height:15.36px; line-height: 22px;">
                    <template v-if="wordafter.wordsorders.text != ''">
                      <specialtext
                        style="max-width: 181px"
                        :text="wordafter.wordsorders.text"
                      ></specialtext>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </v-flex>
        <v-layout wrap style="position: relative; min-height: 280px;">
          <v-premium-plan-popup2
            v-if="!getPackageType().includes('advanced')"
            type="advanced"
            text="Upgrade to Advanced, starting at 990 baht/month to Follow-up customers after receiving the message(s) / order summary to buy or track customers' after-sale service."
          ></v-premium-plan-popup2>
          <v-flex xs12 sm6 class="pa-1">
            <v-divider></v-divider>
            <h4 class="mt-3 mb-2">
              {{ $t('This message will be sent within 24 hours after order summary.') }}
            </h4>
            <template v-if="isEditOrderSummaryMessage">
              <template>
                <div class="form-control" style="display: flow-root;">
                  <toggle-button
                    v-model="wordafter.follow_up_cart_status"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                  {{ $t('Turn on follow up feature') }}
                  <!-- <input
                  type="number"
                  v-model="wordafter.follow_up_cart_within_seconds"
                  pattern="[0-9]*"
                  placeholder="-"
                  inputmode="numeric"
                  class="form-control ml-2 mr-2"
                  style="width: 150px;"
                /> -->
                </div>
              </template>
              <v-layout class="mt-3">
                <v-flex
                  v-if="showMultipleChannel"
                  class="channel"
                  shrink
                  style="border-right: 1px solid #eee"
                >
                  <template v-for="(item1, index) in channelItem">
                    <div
                      v-if="item1.name != 'whatsapp'"
                      :key="index"
                      :class="{ 'primary white--text': tab == item1.name }"
                      @click="tab = item1.name"
                      class="py-1 pl-2 pr-2"
                      style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                    >
                      <span :class="`fab ${item1.icon}`"></span>
                    </div>
                  </template>
                </v-flex>
                <v-flex :key="timestamp">
                  <template v-if="!showMultipleChannel">
                    <intent-group
                      :showMultipleChannel="showMultipleChannel"
                      v-model="messages"
                      :availableBubbles="['text', 'image', 'button']"
                      :followUp="true"
                      @changeSetting="changeSetting"
                    ></intent-group>
                  </template>
                  <template v-else>
                    <template v-if="tab == 'facebook'">
                      <keep-alive>
                        <intent-group
                          key="fb_message"
                          v-model="fb_messages"
                          :showMultipleChannel="showMultipleChannel"
                          :channel="tab"
                          @changeSetting="changeSetting"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab == 'line'">
                      <keep-alive>
                        <intent-group
                          key="line_message"
                          v-model="line_messages"
                          :showMultipleChannel="showMultipleChannel"
                          @changeSetting="changeSetting"
                          :channel="tab"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab == 'instagram'">
                      <keep-alive>
                        <intent-group
                          key="ig_message"
                          v-model="ig_messages"
                          :showMultipleChannel="showMultipleChannel"
                          @changeSetting="changeSetting"
                          :channel="tab"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab == 'google'">
                      <keep-alive>
                        <intent-group
                          key="google_message"
                          v-model="google_messages"
                          :showMultipleChannel="showMultipleChannel"
                          @changeSetting="changeSetting"
                          :channel="tab"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                  </template>

                  <div>
                    <div class="small pl-3" style="margin-top: 10px">{{ $t('Choice') }}</div>
                    <div class="mb-3"></div>

                    <template v-if="!showMultipleChannel">
                      <div
                        class="form-control pl-3"
                        :class="{ 'has-error': errorTag['follow_up_cart_quick_reply'].length > 0 }"
                      >
                        <tags
                          v-model="follow_up_cart_reply"
                          :tags="follow_up_cart_quick_reply"
                          @tags-changed="addReplies('follow_up_cart_quick_reply', $event)"
                          @before-adding-tag="checkQuickReply('follow_up_cart_quick_reply', $event)"
                          style="margin-bottom: 5px"
                          :btnText="$t('Add choice')"
                        ></tags>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="form-control pl-3"
                        :class="{ 'has-error': errorTag[`${tab}`].length > 0 }"
                      >
                        <tags
                          v-model="follow_up_cart_reply"
                          :tags="
                            tab == 'facebook'
                              ? follow_up_cart_fb_quick_reply
                              : tab == 'line'
                              ? follow_up_cart_line_quick_reply
                              : tab == 'instagram'
                              ? follow_up_cart_ig_quick_reply
                              : tab == 'google'
                              ? follow_up_cart_google_quick_reply
                              : follow_up_cart_whatsapp_quick_reply
                          "
                          @tags-changed="addReplies(tab, $event)"
                          @before-adding-tag="checkQuickReply(`${tab}`, $event)"
                          style="margin-bottom: 5px"
                          :btnText="$t('Add choice')"
                        ></tags>
                      </div>
                    </template>
                    <div class="form-control has-error">
                      <template v-for="(error, errorKey) in errorTag">
                        <span :key="errorKey" class="text-error" v-if="error.length > 0">
                          <template v-if="error.includes('overmaxlength')">{{
                            $t('Message cannot be longer than 20 alphabets')
                          }}</template>
                          <template v-else-if="error.includes('overtagmax')">{{
                            $t('Choices cannot be more than 10 items')
                          }}</template>
                          <template v-else-if="error.includes('duplicate')">{{
                            $t('Duplicate Choice')
                          }}</template>
                        </span>
                      </template>
                    </div>
                  </div>
                  <div class="mt-2 pl-3">
                    <div v-if="tab == 'line'">{{ $t('setting_followup_date_time_payment') }}</div>
                    <div v-else>{{ $t('Schedule follow up time (Hours:Minutes)') }}</div>
                  </div>
                  <v-layout v-show="!showMultipleChannel && tab == 'all'">
                    <v-flex xs12 class="ma-2 pl-2">
                      <time-picker
                        class="mt-1"
                        v-model="wordafter.follow_up_cart_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_cart_within_seconds ||
                          (wordafter.follow_up_cart_within_seconds &&
                            (wordafter.follow_up_cart_within_seconds.HH === '' ||
                              wordafter.follow_up_cart_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-show="showMultipleChannel && tab != 'all'"
                    style="align-items: center;"
                  >
                    <v-flex
                      v-show="tab == 'line'"
                      xs12
                      md5
                      class="grey--text text-xs-center ma-2 pa-1 lineFollowupText"
                      >{{ $t('customer_ignore_long_time') }}</v-flex
                    >
                    <v-flex
                      v-show="tab == 'line'"
                      xs12
                      md7
                      class="ma-2"
                      style="display: flex;justify-content: space-between;"
                    >
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <div class="form-control mr-2">
                            <input
                              type="text"
                              style="max-width: 100px;min-width:80px"
                              :value="
                                `${wordafter.follow_up_cart_line_within_seconds_date || 0} (${$t(
                                  'day(s)'
                                )})`
                              "
                              v-on="on"
                              @input="
                                wordafter.follow_up_cart_line_within_seconds_date =
                                  $event.target.value
                              "
                            />
                          </div>
                        </template>
                        <v-list
                          style="display: flex; flex-direction: column; max-height: 200px; overflow-y: scroll;"
                        >
                          <v-list
                            v-for="(item, index) in values"
                            :key="index"
                            @click="wordafter.follow_up_cart_line_within_seconds_date = item"
                            style="cursor: pointer; margin-top: 8px;"
                            class="text-xs-center line-followup"
                          >
                            <v-list-tile>{{ item }}</v-list-tile>
                          </v-list>
                        </v-list>
                      </v-menu>
                      <time-picker
                        v-model="wordafter.follow_up_cart_line_within_seconds"
                        full-width
                        :minRange="
                          (!wordafter.follow_up_cart_line_within_seconds ||
                            (wordafter.follow_up_cart_line_within_seconds &&
                              (wordafter.follow_up_cart_line_within_seconds.HH === '' ||
                                wordafter.follow_up_cart_line_within_seconds.HH === '00'))) &&
                          wordafter.follow_up_cart_line_within_seconds_date !== 0
                            ? [[0, 55]]
                            : (!wordafter.follow_up_cart_line_within_seconds ||
                                (wordafter.follow_up_cart_line_within_seconds &&
                                  (wordafter.follow_up_cart_line_within_seconds.HH === '' ||
                                    wordafter.follow_up_cart_line_within_seconds.HH === '00'))) &&
                              wordafter.follow_up_cart_line_within_seconds_date === 0
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab == 'facebook'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_cart_fb_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_cart_fb_within_seconds ||
                          (wordafter.follow_up_cart_fb_within_seconds &&
                            (wordafter.follow_up_cart_fb_within_seconds.HH === '' ||
                              wordafter.follow_up_cart_fb_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab == 'instagram'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_cart_ig_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_cart_ig_within_seconds ||
                          (wordafter.follow_up_cart_ig_within_seconds &&
                            (wordafter.follow_up_cart_ig_within_seconds.HH === '' ||
                              wordafter.follow_up_cart_ig_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab == 'google'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_cart_google_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_cart_google_within_seconds ||
                          (wordafter.follow_up_cart_google_within_seconds &&
                            (wordafter.follow_up_cart_google_within_seconds.HH === '' ||
                              wordafter.follow_up_cart_google_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                  </v-layout>
                  <div class="my-4">
                    <div class="hr"></div>
                    <div class="text-xs-center" style="margin: -13px">
                      <a
                        class="text btn-advanced"
                        href="javascript:void(0);"
                        @click="showAdvanced.first = !showAdvanced.first"
                        style="position: relative"
                      >
                        {{ $t('Advanced') }}
                        <i
                          class="fa"
                          :class="{
                            'fa-angle-down': !showAdvanced.first,
                            'fa-angle-up': showAdvanced.first
                          }"
                        ></i>
                        <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
                      </a>
                    </div>

                    <template>
                      <div
                        style="margin-top: 25px"
                        v-show="
                          showAdvanced.first || errors.has('context_in') || errors.has('startdate')
                        "
                      >
                        <v-tabs
                          v-model="advancedCartTab"
                          slider-color="primary"
                          touchless
                          show-arrows
                        >
                          <v-tab key="customer" href="#customer" ripple
                            >{{ $t('Customer') }}
                            <a @click="openLink('https://tinyurl.com/2rs9ahu7')"
                              ><i
                                style="font-size: 18px; color: #ed1e79;"
                                class="ml-1 fas fa-question-circle"
                              ></i></a
                          ></v-tab>
                        </v-tabs>
                        <v-tab-item v-show="advancedCartTab === 'customer'">
                          <v-card
                            flat
                            :style="{
                              'min-height':
                                $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                            }"
                          >
                            <v-premium-plan-popup
                              :showAll="false"
                              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                            ></v-premium-plan-popup>
                            <v-card-text>
                              <div class="form-control mb-2">
                                <div class="primary--text caption">{{ $t('Status') }}</div>
                                <v-layout wrap>
                                  <v-flex sm11>
                                    <multiselect
                                      :options="statusOptions"
                                      v-model="wordafter.follow_up_cart_userstatus"
                                      :multiple="false"
                                      :taggable="true"
                                      @tag="onSelectCartStatus"
                                    >
                                    </multiselect>
                                    <!-- <small style="color:red" v-if="errorMaxlength">
                                      {{ $t('message_cannot_be_longer_than_25_alphabets') }}
                                    </small> -->
                                  </v-flex>
                                  <v-flex sm1>
                                    <v-btn
                                      samll
                                      icon
                                      @click="wordafter.follow_up_cart_userstatus = null"
                                    >
                                      <v-icon>close</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <div>
                                <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                                <tags
                                  :combobox="true"
                                  v-model="wordafter.follow_up_cart_usertags"
                                  :key="`tagOptions_${timestamp}`"
                                  :tags="cartTags"
                                  @tags-changed="addUserCartTags"
                                  @before-adding-tag="checkUserCartTags"
                                  :itemOption="tagOptions"
                                  style="margin-bottom: 5px"
                                  :btnText="$t('Add tag')"
                                ></tags>

                                <small style="color:red" v-if="errorMaxlengthTags">
                                  {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                                >
                                <!-- <div class="caption">
                          {{ $t('Learn more') }}
                          <a
                            href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ $t('click here') }}</a
                          >
                        </div> -->
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </div>
                    </template>
                  </div>
                  <div class="mt-3 mb-3 text-xs-center">
                    <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                      <i class="far fa-eye"></i>
                      {{ $t('preview') }}
                    </a>
                    <preview-message
                      v-if="showPreview"
                      @close="showPreview = false"
                      :messages="messagesPreview"
                      :choice="quickReplyPreview"
                    ></preview-message>
                  </div>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <p>
                {{ $t('status') }}
                <span v-if="wordafter.follow_up_cart_status">
                  <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
                ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
              </p>
              <template v-if="!showMultipleChannel">
                <p v-if="wordafter && wordafter.follow_up_cart_within_seconds">
                  <span>{{ wordafter.follow_up_cart_within_seconds.HH }} {{ $t('hour') }}</span>
                  <span>{{ wordafter.follow_up_cart_within_seconds.mm }} {{ $t('minute') }}</span>
                </p>
              </template>
              <template v-else>
                <p v-if="wordafter.follow_up_cart_fb_within_seconds && tab == 'facebook'">
                  <span>
                    {{
                      (parseInt(wordafter.follow_up_cart_fb_within_seconds.HH) || '00')
                        .toString()
                        .padStart(2, '0')
                    }}
                    {{ $t('hour') }}
                  </span>
                  <span>
                    {{
                      (parseInt(wordafter.follow_up_cart_fb_within_seconds.mm) || '00')
                        .toString()
                        .padStart(2, '0')
                    }}
                    {{ $t('minute') }}
                  </span>
                </p>
                <p v-if="wordafter.follow_up_cart_line_within_seconds && tab == 'line'">
                  <span
                    >{{ wordafter.follow_up_cart_line_within_seconds.DD || '00' }}
                    {{ $t('Days') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_cart_line_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_cart_line_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
                <p v-if="wordafter.follow_up_cart_ig_within_seconds && tab == 'instagram'">
                  <span
                    >{{ wordafter.follow_up_cart_ig_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_cart_ig_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
                <p v-if="wordafter.follow_up_cart_google_within_seconds && tab == 'google'">
                  <span
                    >{{ wordafter.follow_up_cart_google_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_cart_google_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
              </template>
              <v-layout class="mt-3">
                <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                  <p>{{ $t('Chatbot answers') }}</p>
                  <template v-if="wordafter.follow_up_cart_type == 'json'">
                    <template v-if="!showMultipleChannel">
                      <template v-if="messages && messages[0].length > 0">
                        <message-viewer v-model="messages" :channel="tab"></message-viewer>
                      </template>
                      <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                    </template>
                    <template v-else>
                      <v-layout>
                        <v-flex
                          v-if="showMultipleChannel"
                          class="channel"
                          shrink
                          style="border-right: 1px solid #eee"
                        >
                          <template v-for="(item1, index) in channelItem">
                            <div
                              v-if="item1.name != 'whatsapp'"
                              :key="index"
                              :class="{ 'primary white--text': tab == item1.name }"
                              @click="tab = item1.name"
                              class="py-1 pl-2 pr-2"
                              style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                            >
                              <span :class="`fab ${item1.icon}`"></span>
                            </div>
                          </template>
                        </v-flex>
                        <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                          <template v-if="tab == 'facebook'">
                            <template v-if="fb_messages && fb_messages[0].length > 0">
                              <message-viewer v-model="fb_messages" :channel="tab"></message-viewer>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab == 'line'">
                            <template v-if="line_messages && line_messages[0].length > 0">
                              <message-viewer
                                v-model="line_messages"
                                :channel="tab"
                              ></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('line')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{
                                  $t('Upgrade to {package} Plan', {
                                    package: $t('PREMIUM')
                                  })
                                }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab == 'instagram'">
                            <template v-if="ig_messages && ig_messages[0].length > 0">
                              <message-viewer v-model="ig_messages" :channel="tab"></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('instagram')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab == 'google'">
                            <template v-if="google_messages && google_messages[0].length > 0">
                              <message-viewer
                                v-model="google_messages"
                                :channel="tab"
                              ></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('google')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                  <template>
                    <div>
                      <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                      <div class="quickreply">
                        <template v-if="replies.length > 0">
                          <ul class="tags">
                            <li
                              class="tag"
                              v-for="(reply, index) in replies"
                              :key="'replies' + index"
                            >
                              {{ reply }}
                            </li>
                          </ul>
                        </template>
                        <template v-else>-</template>
                      </div>
                    </div>
                  </template>
                  <template>
                    <v-tabs v-model="advancedCartTab" slider-color="primary" touchless show-arrows>
                      <v-tab key="customer" :href="'#customer'" ripple>{{ $t('Customer') }}</v-tab>
                      <v-tab-item key="customer" :value="'customer'">
                        <v-card flat>
                          <v-card-text>
                            <div>
                              <div class="caption">{{ $t('Status') }}</div>
                              <p class="primary-color">
                                {{
                                  wordafter.follow_up_cart_userstatus
                                    ? wordafter.follow_up_cart_userstatus
                                    : '-'
                                }}
                              </p>
                            </div>
                            <div>
                              <div class="caption">{{ $t('Tag') }}</div>
                              <ul class="tags pt-1">
                                <li
                                  class="tag"
                                  v-for="(carttag, index) in cartTags"
                                  :key="'carttag_' + index"
                                >
                                  <specialtext :text="carttag.text"></specialtext>
                                </li>
                              </ul>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </template>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>
          <v-flex xs12 sm6 class="pa-1">
            <v-divider></v-divider>
            <h4 class="mt-3 mb-2">
              {{
                $t(
                  'This message will be sent to provide after-sales service within 24 hours when customer get order No.'
                )
              }}
            </h4>
            <template v-if="isEditOrderSummaryMessage">
              <template>
                <div class="form-control" style="display: flow-root;">
                  <toggle-button
                    v-model="wordafter.follow_up_order_status"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                  {{ $t('Turn on follow up feature') }}
                  <!-- <input
                  type="number"
                  v-model="wordafter.follow_up_order_within_seconds"
                  pattern="[0-9]*"
                  placeholder="-"
                  inputmode="numeric"
                  class="form-control ml-2 mr-2"
                  style="width: 150px;"
                />
                <span> {{ $t('วินาที') }}</span> -->
                  <!-- <div class="mt-2">{{ $t('Schedule follow up time (Hours:Minutes)') }}</div>
                  <time-picker
                    class="mt-1"
                    v-model="wordafter.follow_up_order_within_seconds"
                    full-width
                    :minRange="
                      !wordafter.follow_up_order_within_seconds ||
                      (wordafter.follow_up_order_within_seconds &&
                        (wordafter.follow_up_order_within_seconds.HH === '' ||
                          wordafter.follow_up_order_within_seconds.HH === '00'))
                        ? [[5, 55]]
                        : null
                    "
                    :minute-interval="5"
                    hide-disabled-minutes
                  ></time-picker> -->
                </div>
              </template>

              <v-layout class="mt-3">
                <v-flex
                  v-if="showMultipleChannelFollowUp"
                  class="channel"
                  shrink
                  style="border-right: 1px solid #eee"
                >
                  <template v-for="(item2, index) in channelItem">
                    <div
                      v-if="item2.name != 'whatsapp'"
                      :key="index"
                      :class="{ 'primary white--text': tab2 == item2.name }"
                      @click="tab2 = item2.name"
                      class="py-1 pl-2 pr-2"
                      style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                    >
                      <span :class="`fab ${item2.icon}`"></span>
                    </div>
                  </template>
                </v-flex>
                <v-flex :key="timestamp">
                  <template v-if="!showMultipleChannelFollowUp">
                    <intent-group
                      :showMultipleChannel="showMultipleChannelFollowUp"
                      v-model="messages2"
                      :availableBubbles="['text', 'image', 'button']"
                      :followUp="true"
                      @changeSetting="changeSettingFollowUp"
                    ></intent-group>
                  </template>
                  <template v-else>
                    <template v-if="tab2 == 'facebook'">
                      <keep-alive>
                        <intent-group
                          key="fb_message"
                          v-model="fb_messages2"
                          :showMultipleChannel="showMultipleChannelFollowUp"
                          :channel="tab2"
                          @changeSetting="changeSettingFollowUp"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab2 == 'line'">
                      <keep-alive>
                        <intent-group
                          key="line_message"
                          v-model="line_messages2"
                          :showMultipleChannel="showMultipleChannelFollowUp"
                          @changeSetting="changeSettingFollowUp"
                          :channel="tab2"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab2 == 'instagram'">
                      <keep-alive>
                        <intent-group
                          key="ig_message"
                          v-model="ig_messages2"
                          :showMultipleChannel="showMultipleChannelFollowUp"
                          @changeSetting="changeSettingFollowUp"
                          :channel="tab2"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                    <template v-else-if="tab2 == 'google'">
                      <keep-alive>
                        <intent-group
                          key="google_message"
                          v-model="google_messages2"
                          :showMultipleChannel="showMultipleChannelFollowUp"
                          @changeSetting="changeSettingFollowUp"
                          :channel="tab2"
                          :availableBubbles="['text', 'image', 'button']"
                          :followUp="true"
                        ></intent-group>
                      </keep-alive>
                    </template>
                  </template>

                  <div>
                    <div class="small pl-3" style="margin-top: 10px">{{ $t('Choice') }}</div>
                    <div class="mb-3"></div>

                    <template v-if="!showMultipleChannelFollowUp">
                      <div
                        class="form-control pl-3"
                        :class="{ 'has-error': errorTag['follow_up_order_quick_reply'].length > 0 }"
                      >
                        <tags
                          v-model="follow_up_order_reply"
                          :tags="follow_up_order_quick_reply"
                          @tags-changed="followUpAddReplies('follow_up_order_quick_reply', $event)"
                          @before-adding-tag="checkQuickReply('follow_up_replies', $event)"
                          style="margin-bottom: 5px"
                          :btnText="$t('Add choice')"
                        ></tags>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="form-control pl-3"
                        :class="{ 'has-error': errorTag[`${tab2}`].length > 0 }"
                      >
                        <tags
                          v-model="follow_up_order_reply"
                          :tags="
                            tab2 == 'facebook'
                              ? follow_up_order_fb_quick_reply
                              : tab2 == 'line'
                              ? follow_up_order_line_quick_reply
                              : tab2 == 'instagram'
                              ? follow_up_order_ig_quick_reply
                              : follow_up_order_google_quick_reply
                          "
                          @tags-changed="followUpAddReplies(tab2, $event)"
                          @before-adding-tag="checkQuickReply(`follow_up_${tab2}`, $event)"
                          style="margin-bottom: 5px"
                          :btnText="$t('Add choice')"
                        ></tags>
                      </div>
                    </template>
                    <div class="form-control has-error">
                      <template v-for="(error, errorKey) in errorTag">
                        <span :key="errorKey" class="text-error" v-if="error.length > 0">
                          <template v-if="error.includes('overmaxlength')">{{
                            $t('Message cannot be longer than 20 alphabets')
                          }}</template>
                          <template v-else-if="error.includes('overtagmax')">{{
                            $t('Choices cannot be more than 10 items')
                          }}</template>
                          <template v-else-if="error.includes('duplicate')">{{
                            $t('Duplicate Choice')
                          }}</template>
                        </span>
                      </template>
                    </div>
                  </div>
                  <div class="mt-2 pl-3">
                    <div v-if="tab2 == 'line'">{{ $t('setting_followup_date_time_payment') }}</div>
                    <div v-else>{{ $t('Schedule follow up time (Hours:Minutes)') }}</div>
                  </div>
                  <v-layout v-show="!showMultipleChannelFollowUp && tab2 == 'all'">
                    <v-flex xs12 class="ma-2 pl-2">
                      <time-picker
                        class="mt-1"
                        v-model="wordafter.follow_up_order_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_order_within_seconds ||
                          (wordafter.follow_up_order_within_seconds &&
                            (wordafter.follow_up_order_within_seconds.HH === '' ||
                              wordafter.follow_up_order_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-show="showMultipleChannelFollowUp && tab2 != 'all'"
                    style="align-items: center;"
                  >
                    <v-flex
                      v-show="tab2 == 'line'"
                      xs12
                      md4
                      class="grey--text text-xs-center ma-2 pa-1 lineFollowupText"
                      >{{ $t('customer_ignore_long_time') }}</v-flex
                    >
                    <v-flex
                      v-show="tab2 == 'line'"
                      xs12
                      md7
                      class="ma-2"
                      style="display: flex;justify-content: space-between;"
                    >
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <div class="form-control mr-2">
                            <input
                              type="text"
                              style="max-width: 100px;min-width:80px"
                              :value="
                                `${wordafter.follow_up_order_line_within_seconds_date || 0} (${$t(
                                  'day(s)'
                                )})`
                              "
                              v-on="on"
                              @input="
                                wordafter.follow_up_order_line_within_seconds_date =
                                  $event.target.value
                              "
                            />
                          </div>
                        </template>
                        <v-list
                          style="display: flex; flex-direction: column; max-height: 200px; overflow-y: scroll;"
                        >
                          <v-list
                            v-for="(item, index) in values"
                            :key="index"
                            @click="wordafter.follow_up_order_line_within_seconds_date = item"
                            style="cursor: pointer; margin-top: 8px;"
                            class="text-xs-center line-followup"
                          >
                            <v-list-tile>{{ item }}</v-list-tile>
                          </v-list>
                        </v-list>
                      </v-menu>
                      <time-picker
                        v-model="wordafter.follow_up_order_line_within_seconds"
                        full-width
                        :minRange="
                          (!wordafter.follow_up_order_line_within_seconds ||
                            (wordafter.follow_up_order_line_within_seconds &&
                              (wordafter.follow_up_order_line_within_seconds.HH === '' ||
                                wordafter.follow_up_order_line_within_seconds.HH === '00'))) &&
                          wordafter.follow_up_order_line_within_seconds_date !== 0
                            ? [[0, 55]]
                            : (!wordafter.follow_up_order_line_within_seconds ||
                                (wordafter.follow_up_order_line_within_seconds &&
                                  (wordafter.follow_up_order_line_within_seconds.HH === '' ||
                                    wordafter.follow_up_order_line_within_seconds.HH === '00'))) &&
                              wordafter.follow_up_order_line_within_seconds_date === 0
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab2 == 'facebook'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_order_fb_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_order_fb_within_seconds ||
                          (wordafter.follow_up_order_fb_within_seconds &&
                            (wordafter.follow_up_order_fb_within_seconds.HH === '' ||
                              wordafter.follow_up_order_fb_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab2 == 'instagram'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_order_ig_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_order_ig_within_seconds ||
                          (wordafter.follow_up_order_ig_within_seconds &&
                            (wordafter.follow_up_order_ig_within_seconds.HH === '' ||
                              wordafter.follow_up_order_ig_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                    <v-flex v-show="tab2 == 'google'" xs12 class="ma-2 pl-2">
                      <time-picker
                        v-model="wordafter.follow_up_order_google_within_seconds"
                        full-width
                        :minRange="
                          !wordafter.follow_up_order_google_within_seconds ||
                          (wordafter.follow_up_order_google_within_seconds &&
                            (wordafter.follow_up_order_google_within_seconds.HH === '' ||
                              wordafter.follow_up_order_google_within_seconds.HH === '00'))
                            ? [[5, 55]]
                            : null
                        "
                        :minute-interval="5"
                        hide-disabled-minutes
                      ></time-picker>
                    </v-flex>
                  </v-layout>
                  <div class="my-4">
                    <div class="hr"></div>
                    <div class="text-xs-center" style="margin: -13px">
                      <a
                        class="text btn-advanced"
                        href="javascript:void(0);"
                        @click="showAdvanced.second = !showAdvanced.second"
                        style="position: relative"
                      >
                        {{ $t('Advanced') }}
                        <i
                          class="fa"
                          :class="{
                            'fa-angle-down': !showAdvanced.second,
                            'fa-angle-up': showAdvanced.second
                          }"
                        ></i>
                        <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
                      </a>
                    </div>

                    <template>
                      <div
                        style="margin-top: 25px"
                        v-show="
                          showAdvanced.second || errors.has('context_in') || errors.has('startdate')
                        "
                      >
                        <v-tabs
                          v-model="advancedOrderTab"
                          slider-color="primary"
                          touchless
                          show-arrows
                        >
                          <v-tab key="customer" href="#customer" ripple
                            >{{ $t('Customer') }}
                            <a @click="openLink('https://tinyurl.com/2rs9ahu7')"
                              ><i
                                style="font-size: 18px; color: #ed1e79;"
                                class="ml-1 fas fa-question-circle"
                              ></i></a
                          ></v-tab>
                        </v-tabs>
                        <v-tab-item v-show="advancedOrderTab === 'customer'">
                          <v-card
                            flat
                            :style="{
                              'min-height':
                                $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                            }"
                          >
                            <v-premium-plan-popup
                              :showAll="false"
                              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                            ></v-premium-plan-popup>
                            <v-card-text>
                              <div class="form-control mb-2">
                                <div class="primary--text caption">{{ $t('Status') }}</div>
                                <v-layout wrap>
                                  <v-flex sm11>
                                    <multiselect
                                      :options="statusOptions"
                                      v-model="wordafter.follow_up_order_userstatus"
                                      :multiple="false"
                                      :taggable="true"
                                      @input="errorMaxlength = false"
                                      @tag="onSelectOrderStatus"
                                    >
                                    </multiselect>
                                    <small style="color:red" v-if="errorMaxlength">
                                      {{ $t('message_cannot_be_longer_than_25_alphabets') }}
                                    </small>
                                  </v-flex>
                                  <v-flex sm1>
                                    <v-btn
                                      samll
                                      icon
                                      @click="wordafter.follow_up_order_userstatus = null"
                                    >
                                      <v-icon>close</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <div>
                                <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                                <tags
                                  :combobox="true"
                                  v-model="wordafter.follow_up_order_usertags"
                                  :key="`tagOptions_${timestamp}`"
                                  :tags="orderTags"
                                  @tags-changed="addUserOrderTags"
                                  @before-adding-tag="checkUserOrderTags"
                                  :itemOption="tagOptions"
                                  style="margin-bottom: 5px"
                                  :btnText="$t('Add tag')"
                                ></tags>

                                <small style="color:red" v-if="errorMaxlengthTags">
                                  {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                                >
                                <!-- <div class="caption">
                          {{ $t('Learn more') }}
                          <a
                            href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ $t('click here') }}</a
                          >
                        </div> -->
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </div>
                    </template>
                  </div>
                  <div class="mt-3 mb-3 text-xs-center">
                    <a href="javascript:void(0);" class="btn-preview" @click="showPreview2 = true">
                      <i class="far fa-eye"></i>
                      {{ $t('preview') }}
                    </a>
                    <preview-message
                      v-if="showPreview2"
                      @close="showPreview2 = false"
                      :messages="messagesPreview2"
                      :choice="quickReplyPreview2"
                    ></preview-message>
                  </div>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <p>
                {{ $t('status') }}
                <span v-if="wordafter.follow_up_order_status">
                  <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
                ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
              </p>
              <template v-if="!showMultipleChannelFollowUp">
                <p v-if="wordafter && wordafter.follow_up_order_within_seconds">
                  <span>{{ wordafter.follow_up_order_within_seconds.HH }} {{ $t('hour') }}</span>
                  <span>{{ wordafter.follow_up_order_within_seconds.mm }} {{ $t('minute') }}</span>
                </p>
              </template>
              <template v-else>
                <p v-if="wordafter.follow_up_order_fb_within_seconds && tab2 == 'facebook'">
                  <span>
                    {{
                      (parseInt(wordafter.follow_up_order_fb_within_seconds.HH) || '00')
                        .toString()
                        .padStart(2, '0')
                    }}
                    {{ $t('hour') }}
                  </span>
                  <span>
                    {{
                      (parseInt(wordafter.follow_up_order_fb_within_seconds.mm) || '00')
                        .toString()
                        .padStart(2, '0')
                    }}
                    {{ $t('minute') }}
                  </span>
                </p>
                <p v-if="wordafter.follow_up_order_line_within_seconds && tab2 == 'line'">
                  <span
                    >{{ wordafter.follow_up_order_line_within_seconds.DD || '00' }}
                    {{ $t('Days') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_order_line_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_order_line_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
                <p v-if="wordafter.follow_up_order_ig_within_seconds && tab2 == 'instagram'">
                  <span
                    >{{ wordafter.follow_up_order_ig_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_order_ig_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
                <p v-if="wordafter.follow_up_order_google_within_seconds && tab2 == 'google'">
                  <span
                    >{{ wordafter.follow_up_order_google_within_seconds.HH || '00' }}
                    {{ $t('hour') }}</span
                  >
                  <span
                    >{{ wordafter.follow_up_order_google_within_seconds.mm || '00' }}
                    {{ $t('minute') }}</span
                  >
                </p>
              </template>
              <v-layout class="mt-3">
                <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                  <p>{{ $t('Chatbot answers') }}</p>
                  <template v-if="wordafter.follow_up_order_type == 'json'">
                    <template v-if="!showMultipleChannelFollowUp">
                      <template v-if="messages2 && messages2[0].length > 0">
                        <message-viewer v-model="messages2" :channel="tab2"></message-viewer>
                      </template>
                      <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                    </template>
                    <template v-else>
                      <v-layout>
                        <v-flex
                          v-if="showMultipleChannel"
                          class="channel"
                          shrink
                          style="border-right: 1px solid #eee"
                        >
                          <template v-for="(item2, index) in channelItem">
                            <div
                              v-if="item2.name != 'whatsapp'"
                              :key="index"
                              :class="{ 'primary white--text': tab2 == item2.name }"
                              @click="tab2 = item2.name"
                              class="py-1 pl-2 pr-2"
                              style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                            >
                              <span :class="`fab ${item2.icon}`"></span>
                            </div>
                          </template>
                        </v-flex>
                        <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                          <template v-if="tab2 == 'facebook'">
                            <template v-if="fb_messages2 && fb_messages2[0].length > 0">
                              <message-viewer
                                v-model="fb_messages2"
                                :channel="tab2"
                              ></message-viewer>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab2 == 'line'">
                            <template v-if="line_messages2 && line_messages2[0].length > 0">
                              <message-viewer
                                v-model="line_messages2"
                                :channel="tab2"
                              ></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('line')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{
                                  $t('Upgrade to {package} Plan', {
                                    package: $t('PREMIUM')
                                  })
                                }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab2 == 'instagram'">
                            <template v-if="ig_messages2 && ig_messages2[0].length > 0">
                              <message-viewer
                                v-model="ig_messages2"
                                :channel="tab2"
                              ></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('instagram')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                          <template v-else-if="tab2 == 'google'">
                            <template v-if="google_messages2 && google_messages2[0].length > 0">
                              <message-viewer
                                v-model="google_messages2"
                                :channel="tab2"
                              ></message-viewer>

                              <v-premium-lock2
                                :value="!check_privilege('google')"
                                type="premium"
                                class="mt-2"
                              >
                                <span class="pl-2">{{ $t('Upgrade to Premium Plan') }}</span>
                              </v-premium-lock2>
                            </template>
                            <p v-else class="primary-color pl-1">
                              {{ $t('No reply') }}
                            </p>
                          </template>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                  <template>
                    <div>
                      <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                      <div class="quickreply">
                        <template v-if="follow_up_quick_reply.length > 0">
                          <ul class="tags">
                            <li
                              class="tag"
                              v-for="(reply, index) in follow_up_quick_reply"
                              :key="'follow_up_quick_reply' + index"
                            >
                              {{ reply }}
                            </li>
                          </ul>
                        </template>
                        <template v-else>-</template>
                      </div>
                    </div>
                  </template>
                  <template>
                    <v-tabs v-model="advancedOrderTab" slider-color="primary" touchless show-arrows>
                      <v-tab key="customer" :href="'#customer'" ripple>{{ $t('Customer') }}</v-tab>
                      <v-tab-item key="customer" :value="'customer'">
                        <v-card flat>
                          <v-card-text>
                            <div>
                              <div class="caption">{{ $t('Status') }}</div>
                              <p class="primary-color">
                                {{
                                  wordafter.follow_up_order_userstatus
                                    ? wordafter.follow_up_order_userstatus
                                    : '-'
                                }}
                              </p>
                            </div>
                            <div>
                              <div class="caption">{{ $t('Tag') }}</div>
                              <ul class="tags pt-1">
                                <li
                                  class="tag"
                                  v-for="(ordertag, index) in orderTags"
                                  :key="'ordertag_' + index"
                                >
                                  <specialtext :text="ordertag.text"></specialtext>
                                </li>
                              </ul>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </template>
                </v-flex>
              </v-layout>
              <!-- </div>
            </template> -->
            </template>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
    <!-- <v-divider></v-divider> -->
    <div class="text-xs-center mt-3" v-if="isEditOrderSummaryMessage">
      <v-btn outline color="grey" @click="cancelEditWordAfterOrderAndCartSummary">{{
        $t('cancel')
      }}</v-btn>
      <v-btn depressed color="primary" @click="saveWordAfterOrderAndCartSummary">{{
        $t('Save')
      }}</v-btn>
    </div>
    <div class="hr" style="margin-top: 20px; border-color: rgba(0,0,0,.12);"></div>

    <v-container v-if="lineMyShopActive" style="width:100% !important; max-width: 1000px;">
      <lineShoppingOrder />
    </v-container>
    <v-container style="max-width: 1000px"> </v-container>

    <div class="mb-5 mt-5"></div>
  </div>
</template>

<script>
import InputBooleanNoLabel from '@/components/view/setting/input-no-label/InputBooleanNoLabel'
import TransferPayment from '@/components/view/setting/ecommerce/TransferPayment'
import PreviewMessage from '@/components/elements/PreviewMessage'
import { mapGetters } from 'vuex'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import Tags from '@/components/elements/Tags'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import Multiselect from 'vue-multiselect'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewReceiptViewer from '@/components/elements/ViewReceiptViewer'
import specialtext from '@/components/elements/specialtext'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import FbpayPayment from './FbpayPayment'
import GbprimePayment from './GbprimePayment'
import TaxInvoice from './TaxInvoice'
import ShopOption from '@/components/view/setting/ecommerce/ShopOption'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentGroup from '@/components/view/intent/IntentGroup'
import MessageViewer from '@/components/elements/MessageViewer'
import TimePicker from '@/components/elements/TimePicker.vue'
import IntentPrefillVerifySlip from '@/components/view/intent/IntentPrefillVerifySlip'
import IntentGroupItem from '@/components/view/intent/IntentGroupItem.js'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import lineShoppingOrder from '@/components/elements/lineShoppingOrder'

export default {
  data: function() {
    return {
      dialogVerifyBank: false,
      verifyBankActive: false,
      dataVerifySlip: [],
      timestamp: dayjs().format('x'),
      showMultipleChannel: false,
      showMultipleChannelFollowUp: false,
      errorTag: {
        replies: [],
        facebook: [],
        line: [],
        ig: [],
        google: [],
        follow_up_cart_fb_quick_reply: [],
        follow_up_cart_line_quick_reply: [],
        follow_up_cart_ig_quick_reply: [],
        follow_up_cart_google_quick_reply: [],
        follow_up_cart_whatsapp_quick_reply: [],
        follow_up_cart_quick_reply: [],
        follow_up_order_quick_reply: [],
        follow_up_order_fb_quick_reply: [],
        follow_up_order_line_quick_reply: [],
        follow_up_order_ig_quick_reply: [],
        follow_up_order_google_quick_reply: [],
        follow_up_order_whatsapp_quick_reply: []
      },
      follow_up_cart_reply: '',
      follow_up_order_reply: '',
      showPreview: false,
      showPreview2: false,
      tab: 'all',
      tab2: 'all',
      messages: [[]],
      messages2: [[]],
      fb_messages: [[]],
      fb_messages2: [[]],
      line_messages: [[]],
      line_messages2: [[]],
      ig_messages: [[]],
      ig_messages2: [[]],
      google_messages: [[]],
      google_messages2: [[]],
      whatsapp_messages: [[]],
      whatsapp_messages2: [[]],
      toggle: false,
      is_hide_add_more_btn: false,
      setShopOption: false,
      EditAddress: false,
      shopOption: [
        { label: 'Name', is_require: true, type: 'text', id: '0', message: '' },
        { label: 'Shipping Address', is_require: true, type: 'text', id: '1', message: '' },
        { label: 'Email Address', is_require: true, type: 'email', id: '2', message: '' },
        { label: '', is_require: true, type: 'text', id: '3', message: '' },
        {
          label: 'Tel.',
          is_require: true,
          type: 'text',
          id: '4',
          message: '',
          requiredNineCharacter: true,
          requiredTenCharacter: true
        }
      ],
      isEditShopOption: false,

      isEditPaymentDetail: false,
      isEditShop: false,
      isEditTransfer: false,
      isEditOrderSummaryMessage: false,
      contents: {},
      isTransfer: false,
      isCreditCard: false,
      paypal: {
        paypal_url: null,
        tracking_id: null,
        loading: true,
        checkTracking: false,
        haveTrackingId: false,

        checkingInterval: null,
        checkingTime: 4,
        checkingTimePerInterval: 5000
      },
      profile: {},
      oldProfile: {},
      showHelpRegisterPaypal: false,
      color: '#1CA085',
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        },
        follow_up_cart_userstatus: null,
        follow_up_cart_usertags: '',
        follow_up_order_userstatus: null,
        follow_up_order_usertags: ''
      },
      lineMyShopActive: false,
      values: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
      ],
      showAdvanced: {
        first: false,
        second: false
      },
      advancedCartTab: 'customer',
      advancedOrderTab: 'customer',
      statusOptions: [],
      tagOptions: [],
      errorMaxlengthTags: false,
      errorUserTags: [],
      errorMaxlength: false
    }
  },
  components: {
    Tags,
    PreviewMessage,
    ToggleButton,
    ShopOption,
    TaxInvoice,
    InputBooleanNoLabel,
    TransferPayment,
    IntentGroup,
    ModalDialog,
    Swatches,
    Multiselect,
    ViewCartSummaryViewer,
    ViewReceiptViewer,
    specialtext,
    IntentPrefill,
    AutoresizeTextarea,
    ShopProfile,
    FbpayPayment,
    GbprimePayment,
    MessageViewer,
    TimePicker,
    IntentPrefillVerifySlip,
    lineShoppingOrder
  },
  mixins: [IntentGroupItem],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      paypalTrackingId: 'paypalTrackingId',
      currentLang: 'currentLang',
      getPageProfile: 'getPageProfile',
      isCoachlab: 'isCoachlab',
      userTagItems: 'getUserTags',
      userStatus: 'getUserStatus'
    }),

    quickReplyPreview2: function() {
      var reply = ''
      if (this.tab2 == 'all') {
        reply = this.follow_up_order_quick_reply
      } else if (this.tab2 == 'facebook') {
        reply = this.follow_up_order_fb_quick_reply
      } else if (this.tab2 == 'line') {
        reply = this.follow_up_order_line_quick_reply
      } else if (this.tab2 == 'instagram') {
        reply = this.follow_up_order_ig_quick_reply
      } else if (this.tab2 == 'google') {
        reply = this.follow_up_order_google_quick_reply
      }
      return reply
    },

    quickReplyPreview: function() {
      var reply = ''
      if (this.tab == 'all') {
        reply = this.follow_up_cart_quick_reply
      } else if (this.tab == 'facebook') {
        reply = this.follow_up_cart_fb_quick_reply
      } else if (this.tab == 'line') {
        reply = this.follow_up_cart_line_quick_reply
      } else if (this.tab == 'instagram') {
        reply = this.follow_up_cart_ig_quick_reply
      } else if (this.tab == 'google') {
        reply = this.follow_up_cart_google_quick_reply
      } else if (this.tab == 'whatsapp') {
        reply = this.follow_up_cart_whatsapp_quick_reply
      }
      return reply
    },

    messagesPreview: function() {
      var messages = [[]]
      if (this.tab == 'all') {
        messages = this.messages
      } else if (this.tab == 'facebook') {
        messages = this.fb_messages
      } else if (this.tab == 'line') {
        messages = this.line_messages
      } else if (this.tab == 'instagram') {
        messages = this.ig_messages
      } else if (this.tab == 'google') {
        messages = this.google_messages
      } else if (this.tab == 'whatsapp') {
        messages = this.whatsapp_messages
      }
      return messages
    },

    messagesPreview2: function() {
      var messages2 = [[]]
      if (this.tab2 == 'all') {
        messages2 = this.messages2
      } else if (this.tab2 == 'facebook') {
        messages2 = this.fb_messages2
      } else if (this.tab2 == 'line') {
        messages2 = this.line_messages2
      } else if (this.tab2 == 'instagram') {
        messages2 = this.ig_messages2
      } else if (this.tab2 == 'google') {
        messages2 = this.google_messages2
      } else if (this.tab2 == 'whatsapp') {
        messages2 = this.whatsapp_messages2
      }
      return messages2
    },

    replies: function() {
      var reply = ''
      if (this.tab == 'all') {
        reply = this.wordafter.follow_up_cart_quick_reply
      } else if (this.tab == 'facebook') {
        reply = this.wordafter.follow_up_cart_fb_quick_reply
      } else if (this.tab == 'line') {
        reply = this.wordafter.follow_up_cart_line_quick_reply
      } else if (this.tab == 'instagram') {
        reply = this.wordafter.follow_up_cart_ig_quick_reply
      } else if (this.tab == 'google') {
        reply = this.wordafter.follow_up_cart_google_quick_reply
      } else if (this.tab == 'whatsapp') {
        reply = this.wordafter.follow_up_cart_whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },

    follow_up_quick_reply: function() {
      var reply = ''
      if (this.tab2 == 'all') {
        reply = this.wordafter.follow_up_order_quick_reply
      } else if (this.tab2 == 'facebook') {
        reply = this.wordafter.follow_up_order_fb_quick_reply
      } else if (this.tab2 == 'line') {
        reply = this.wordafter.follow_up_order_line_quick_reply
      } else if (this.tab2 == 'instagram') {
        reply = this.wordafter.follow_up_order_ig_quick_reply
      } else if (this.tab2 == 'google') {
        reply = this.wordafter.follow_up_order_google_quick_reply
      } else if (this.tab2 == 'whatsapp') {
        reply = this.wordafter.follow_up_order_whatsapp_quick_reply
      }
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },

    follow_up_cart_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_quick_reply &&
          vm.wordafter.follow_up_cart_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = vm.wordafter.follow_up_cart_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_quick_reply', result.join(','))
      }
    },

    follow_up_cart_fb_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_fb_quick_reply &&
          vm.wordafter.follow_up_cart_fb_quick_reply !== ''
        ) {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_fb_quick_reply', result.join(','))
      }
    },
    follow_up_cart_line_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_line_quick_reply &&
          vm.wordafter.follow_up_cart_line_quick_reply !== ''
        ) {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_line_quick_reply', result.join(','))
      }
    },
    follow_up_cart_ig_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_ig_quick_reply &&
          vm.wordafter.follow_up_cart_ig_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_ig_quick_reply', result.join(','))
      }
    },
    follow_up_cart_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_cart_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_order_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_cart_google_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_google_quick_reply &&
          vm.wordafter.follow_up_cart_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_google_quick_reply', result.join(','))
      }
    },
    follow_up_cart_whatsapp_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_cart_whatsapp_quick_reply &&
          vm.wordafter.follow_up_cart_whatsapp_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_cart_whatsapp_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_cart_whatsapp_quick_reply', result.join(','))
      }
    },
    follow_up_cart_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_cart_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply_show: function() {
      var reply = ''
      reply = this.wordafter.follow_up_order_quick_reply
      if (reply && reply !== '' && reply != null) {
        var replies = reply.split(',')
        return replies
      } else {
        return []
      }
    },
    follow_up_order_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_quick_reply &&
          vm.wordafter.follow_up_order_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = vm.wordafter.follow_up_order_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_quick_reply', result.join(','))
      }
    },

    follow_up_order_fb_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_fb_quick_reply &&
          vm.wordafter.follow_up_order_fb_quick_reply !== ''
        ) {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_fb_quick_reply', result.join(','))
      }
    },
    follow_up_order_line_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_line_quick_reply &&
          vm.wordafter.follow_up_order_line_quick_reply !== ''
        ) {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_line_quick_reply', result.join(','))
      }
    },
    follow_up_order_ig_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_ig_quick_reply &&
          vm.wordafter.follow_up_order_ig_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_ig_quick_reply', result.join(','))
      }
    },
    follow_up_order_google_quick_reply: {
      get() {
        let vm = this
        if (
          vm.wordafter &&
          vm.wordafter.follow_up_order_google_quick_reply &&
          vm.wordafter.follow_up_order_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.wordafter.a_type === 'message' || vm.wordafter.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.wordafter.follow_up_order_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.wordafter, 'follow_up_order_google_quick_reply', result.join(','))
      }
    },
    cartTags: {
      get() {
        if (this.wordafter.follow_up_cart_usertags) {
          let usertags = []
          usertags = this.wordafter.follow_up_cart_usertags.split(',')
          var result = []
          if (usertags && usertags.length) {
            result = usertags.map(function(tag) {
              return { text: tag }
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }
        this.wordafter.follow_up_cart_usertags = ''
        this.wordafter.follow_up_cart_usertags = result && result.length ? result.join(',') : ''

        // this.$set(this.intent, 'usertags', result.join(','))
      }
    },
    orderTags: {
      get() {
        if (this.wordafter.follow_up_order_usertags) {
          let usertags = []
          usertags = this.wordafter.follow_up_order_usertags.split(',')
          var result = []
          if (usertags && usertags.length) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }
        this.wordafter.follow_up_order_usertags = result && result.length ? result.join(',') : ''

        // this.$set(this.intent, 'usertags', result.join(','))
      }
    }
  },
  created: function() {
    var vm = this
    vm.getWordAfterOrderAndCartSummary()
    vm.paypal.haveTrackingId = vm.paypalTrackingId != null
    vm.paypal.checkTracking = vm.paypal.haveTrackingId && vm.selectedBot.paypal_merchantid == null
    vm.$store.dispatch('loadCharges')
    vm.$store.dispatch('loadSetting')
    vm.$store.dispatch('loadPageProfile')
    vm.getSetting()
    vm.getShopProfile()
    if (vm.selectedBot.theme === 'ecommercebasic') {
      vm.$store.dispatch('loadCategory')
      vm.$store.dispatch('loadProducts')
      if (vm.selectedBot.paypal_merchantid == null) {
        if (vm.paypalTrackingId == null) {
          vm.getPaypalUrl()
        } else {
          if (vm.paypal.checkTracking) {
            vm.onRefreshTrackingStatus()
          }
        }
      }
    }
  },
  mounted: function() {
    const vm = this
    vm.EditAddress = vm.selectedBot.is_allow_user_edit_order
    vm.is_hide_add_more_btn = vm.selectedBot.is_hide_add_more_btn
    if (vm.selectedBot.shop_addon_form_json) {
      vm.shopOption = JSON.parse(vm.selectedBot.shop_addon_form_json)
      vm.setShopOption = vm.selectedBot.shop_addon_form_status
    }

    vm.verifyBankActive = vm.selectedBot.verify_slip_is_active
    try {
      if (vm.selectedBot.line_my_shop_is_active && vm.selectedBot.line_my_shop_api_key) {
        vm.lineMyShopActive = true
      } else {
        vm.lineMyShopActive = false
      }
    } catch (err) {
      console.log(err)
    }

    if (vm.selectedBot.verify_slip_config) {
      vm.isVerify_slip = true
      let b = vm.selectedBot.verify_slip_config.split('^')
      b[b.length - 1] = b[b.length - 1].split('}')[0]
      b.map((item, index) => {
        vm.dataVerifySlip.push({
          id: `${dayjs().format('x')}_${index}`,
          typeAccount:
            item.split('|')[0] === 'promptpay'
              ? { value: 'promptpay', label: 'Promptpay' }
              : { value: 'transfer', label: 'Transfer' },
          bankAccountNo: item.split('|')[1],
          bankName: item.split('|')[0]
        })
      })
    }
    // ;(function(d, s, id) {
    //   var js,
    //     ref = d.getElementsByTagName(s)[0]
    //   if (!d.getElementById(id)) {
    //     js = d.createElement(s)
    //     js.id = id
    //     js.async = true
    //     js.src = 'https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js'
    //     ref.parentNode.insertBefore(js, ref)
    //   }
    // })(document, 'script', 'paypal-js')
    this.getUserTagList()
    this.getUserStatusList()
  },
  methods: {
    setVerifyBankActiveToggle() {
      this.verifyBankActive = !this.verifyBankActive
      this.putConfigVerifySlip()
    },
    getBankName(bankName) {
      const vm = this
      return vm.$store.state.bankForVerify.filter(item => item.value === bankName)[0]
        ? vm.$store.state.bankForVerify.filter(item => item.value === bankName)[0].name_th
        : ''
    },
    async putConfigVerifySlip(payload) {
      const vm = this
      vm.$store.dispatch('loading')
      const data = {
        verify_slip_is_active: vm.verifyBankActive,
        verify_slip_config: payload
      }

      let response = await vm.put(`page/${vm.selectedBot.pageid}/update-page-config`, data)
      if (response.success) {
        this.$store.dispatch('updateBotDetail')
      }
      vm.$store.dispatch('loading')
    },
    onSaveVerifySlipBank(payload) {
      const vm = this
      vm.dataVerifySlip = []
      let dataToPut = null
      if (payload.includes('{verify_slip.bank_info')) {
        let a = payload.split('{verify_slip.bank_info=')
        let b = a[1].split('^')
        b[b.length - 1] = b[b.length - 1].split('}')[0]
        b.map(item => {
          if (item.split('|')[0]) {
            vm.dataVerifySlip.push({
              id: dayjs().format('x'),
              typeAccount:
                item.split('|')[0] === 'promptpay'
                  ? { value: 'promptpay', label: 'Promptpay' }
                  : { value: 'transfer', label: 'Transfer' },
              bankAccountNo: item.split('|')[1],
              bankName: item.split('|')[0]
            })
          }
        })
        dataToPut = a[1].split('},{verify_slip.image}')[0]
      }
      vm.putConfigVerifySlip(dataToPut)
    },
    onClickVerifySlip() {
      const vm = this
      vm.dialogVerifyBank = false
    },
    async changeSettingFollowUp(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          this.showMultipleChannelFollowUp != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages2 = cloneDeep(this.messages2)
          this.fb_messages2 = fb_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          this.line_messages2 = cloneDeep(this.messages2)
          this.ig_messages2 = cloneDeep(this.messages2)
          this.google_messages2 = cloneDeep(this.messages2)
          this.ig_messages2 = this.ig_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])

          this.$set(
            this.wordafter,
            'follow_up_fb_quick_reply',
            this.wordafter.follow_up_order_quick_reply
          )
          this.$set(
            this.wordafter,
            'follow_up_line_quick_reply',
            this.wordafter.follow_up_order_quick_reply
          )
          this.$set(
            this.wordafter,
            'follow_up_ig_quick_reply',
            this.wordafter.follow_up_order_quick_reply
          )
        }
        this.showMultipleChannelFollowUp = payload.showMultipleChannel

        if (this.showMultipleChannelFollowUp) this.tab2 = 'facebook'
        else this.tab2 = 'all'
      }
    },
    async changeSetting(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          this.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages = cloneDeep(this.messages)
          this.fb_messages = fb_messages.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          this.line_messages = cloneDeep(this.messages)
          this.ig_messages = cloneDeep(this.messages)
          this.google_messages = cloneDeep(this.messages2)
          this.ig_messages = this.ig_messages.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])

          this.$set(
            this.wordafter,
            'follow_up_cart_fb_quick_reply',
            this.wordafter.follow_up_cart_quick_reply
          )
          this.$set(
            this.wordafter,
            'follow_up_cart_line_quick_reply',
            this.wordafter.follow_up_cart_quick_reply
          )
          this.$set(
            this.wordafter,
            'follow_up_cart_ig_quick_reply',
            this.wordafter.follow_up_cart_quick_reply
          )
        }
        this.showMultipleChannel = payload.showMultipleChannel

        if (this.showMultipleChannel) this.tab = 'facebook'
        else this.tab = 'all'
      }
    },
    checkQuickReply(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        ((type == 'replies' && this.follow_up_cart_quick_reply.length >= 10) ||
          (type == 'facebook' && this.follow_up_cart_fb_quick_reply.length >= 10) ||
          (type == 'line' && this.follow_up_cart_line_quick_reply.length >= 10) ||
          (type == 'instagram' && this.follow_up_cart_ig_quick_reply.length >= 10) ||
          (type == 'google' && this.follow_up_cart_google_quick_reply.length >= 10) ||
          (type == 'whatsapp' && this.follow_up_cart_whatsapp_quick_reply.length >= 10) ||
          (type == 'follow_up_replies' && this.follow_up_order_quick_reply.length >= 10) ||
          (type == `follow_up_facebook` && this.follow_up_order_fb_quick_reply.length >= 10) ||
          (type == `follow_up_line` && this.follow_up_order_line_quick_reply.length >= 10) ||
          (type == `follow_up_ig` && this.follow_up_order_ig_quick_reply.length >= 10) ||
          (type == `follow_up_google` && this.follow_up_order_google_quick_reply.length >= 10) ||
          (type == `follow_up_whatsapp` && this.follow_up_order_whatsapp_quick_reply.length >= 10))
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },

    addReplies: function(type, newTags) {
      if (type == 'facebook') this.follow_up_cart_fb_quick_reply = newTags
      else if (type == 'line') this.follow_up_cart_line_quick_reply = newTags
      else if (type == 'instagram') this.follow_up_cart_ig_quick_reply = newTags
      else if (type == 'google') this.follow_up_cart_google_quick_reply = newTags
      else if (type == 'whatsapp') this.follow_up_cart_whatsapp_quick_reply = newTags
      else this.follow_up_cart_quick_reply = newTags
    },
    followUpAddReplies: function(type, newTags) {
      if (type == 'facebook') this.follow_up_order_fb_quick_reply = newTags
      else if (type == 'line') this.follow_up_order_line_quick_reply = newTags
      else if (type == 'instagram') this.follow_up_order_ig_quick_reply = newTags
      else if (type == 'google') this.follow_up_order_google_quick_reply = newTags
      else if (type == 'whatsapp') this.follow_up_order_whatsapp_quick_reply = newTags
      else this.follow_up_order_quick_reply = newTags
    },

    // followUpAddOederReplies: function(newTags) {
    //   this.follow_up_order_quick_reply = newTags
    // },
    async onChangeToggle() {
      this.is_hide_add_more_btn = !this.is_hide_add_more_btn
      this.$store.dispatch('loading')
      var data = {
        body: { is_hide_add_more_btn: this.is_hide_add_more_btn },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.is_hide_add_more_btn = !this.is_hide_add_more_btn
      }
      this.$store.dispatch('loading')
    },
    resetShopOption() {
      this.$store.dispatch('updateBotDetail').then(() => {
        this.isEditShopOption = false
        if (this.selectedBot.shop_addon_form_json) {
          this.shopOption = JSON.parse(this.selectedBot.shop_addon_form_json)
          this.setShopOption = this.selectedBot.shop_addon_form_status
        }
      })
    },
    setShopOptionToggle() {
      this.setShopOption = !this.setShopOption
      this.saveShopOption()
    },

    async toggleEditAddress() {
      this.EditAddress = !this.EditAddress
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: vm.selectedBot.pageid,
        body: {
          is_allow_user_edit_order: vm.EditAddress
        }
      }
      try {
        var response = await api.userEditOrder(data)
        if (response) {
          this.EditAddress = response.result.is_allow_user_edit_order
          vm.$store.dispatch('updateBotDetail')
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        this.EditAddress = !vm.EditAddress
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
        })
      }
    },
    async saveShopOption() {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: vm.selectedBot.pageid,
        body: {
          shop_addon_form_status: vm.setShopOption,
          shop_addon_form_json: JSON.stringify(vm.shopOption)
        }
      }
      try {
        var response = await api.putAddonForm(data)
        if (response) {
          vm.isEditShopOption = false
          vm.$store.dispatch('updateBotDetail')
        }
        vm.$store.dispatch('loading')
      } catch (error) {
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
        })
      }
    },
    addWordCartSummaryPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_cart_summary.$el.selectionStart

      vm.wordafter.wordscartsummary.text = [
        vm.wordafter.wordscartsummary.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordscartsummary.text.slice(cursorPosition)
      ].join('')
    },
    addWordOrderPrefill: function(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_orders.$el.selectionStart
      vm.wordafter.wordsorders.text = [
        vm.wordafter.wordsorders.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordsorders.text.slice(cursorPosition)
      ].join('')
    },
    onSelectLang: function(val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    },
    getWordAfterOrderAndCartSummary: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      vm.wordafter.loading = true
      api.getWordAfterOrderAndCartSummary(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.wordafter.loading = false
          return
        }
        if (response.data) {
          vm.wordafter = response.data
          if (
            vm.check_privilege('multichannel') &&
            (vm.wordafter.follow_up_cart_fb_val ||
              vm.wordafter.follow_up_cart_line_val ||
              vm.wordafter.follow_up_cart_ig_val ||
              vm.wordafter.follow_up_cart_google_val)
          ) {
            vm.showMultipleChannel = true
            vm.fb_messages = JSON.parse(vm.wordafter.follow_up_cart_fb_val) || [[]]
            vm.line_messages = JSON.parse(vm.wordafter.follow_up_cart_line_val) || [[]]
            vm.ig_messages = JSON.parse(vm.wordafter.follow_up_cart_ig_val) || [[]]
            vm.google_messages = JSON.parse(vm.wordafter.follow_up_cart_google_val) || [[]]
            vm.tab = 'facebook'
          }

          if (
            vm.check_privilege('multichannel') &&
            (vm.wordafter.follow_up_order_fb_val ||
              vm.wordafter.follow_up_order_line_val ||
              vm.wordafter.follow_up_order_ig_val ||
              vm.wordafter.follow_up_order_google_val)
          ) {
            vm.showMultipleChannelFollowUp = true
            vm.fb_messages2 = JSON.parse(vm.wordafter.follow_up_order_fb_val) || [[]]
            vm.line_messages2 = JSON.parse(vm.wordafter.follow_up_order_line_val) || [[]]
            vm.ig_messages2 = JSON.parse(vm.wordafter.follow_up_order_ig_val) || [[]]
            vm.google_messages2 = JSON.parse(vm.wordafter.follow_up_order_google_val) || [[]]
            vm.tab2 = 'facebook'
          }
          if (response.data.follow_up_cart_val) {
            vm.messages = JSON.parse(response.data.follow_up_cart_val)
          }
          if (response.data.follow_up_order_val) {
            vm.messages2 = JSON.parse(response.data.follow_up_order_val)
          }
          if (response.data.wordscartsummary) {
            vm.wordafter.wordscartsummary = JSON.parse(response.data.wordscartsummary)
          } else {
            vm.wordafter.wordscartsummary = { type: 'text', text: '' }
          }
          if (response.data.wordsorders) {
            vm.wordafter.wordsorders = JSON.parse(response.data.wordsorders)
          } else {
            vm.wordafter.wordsorders = { type: 'text', text: '' }
          }
          if (response.data.buttons_cart_summary) {
            vm.wordafter.buttons_cart_summary = response.data.buttons_cart_summary
          }
          if (response.data.edit_order_buttons) {
            vm.wordafter.edit_order_buttons = response.data.edit_order_buttons
          }
          if (typeof vm.wordafter.follow_up_cart_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_fb_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_fb_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_fb_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_fb_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_line_within_seconds !== 'object') {
            const hours = Math.floor(
              parseInt(vm.wordafter.follow_up_cart_line_within_seconds) / 60 / 60
            )

            let HH = '0' + (hours % 24)
            let DD = hours >= 24 ? Math.floor(hours / 24) : 0
            let mm = (
              '0' +
              JSON.stringify((parseInt(vm.wordafter.follow_up_cart_line_within_seconds) / 60) % 60)
            ).slice(-2)
            if (DD > 0) {
              HH = ('0' + HH).slice(-2)
              DD = ('0' + DD).slice(-2)
              vm.wordafter.follow_up_cart_line_within_seconds = { DD, HH, mm }
            } else {
              HH = ('0' + HH).slice(-2)
              vm.wordafter.follow_up_cart_line_within_seconds = { HH, mm }
            }
            if (hours >= 24) {
              vm.wordafter.follow_up_cart_line_within_seconds_date = Math.floor(hours / 24)
            } else {
              vm.wordafter.follow_up_cart_line_within_seconds_date = 0
            }
          }
          if (typeof vm.wordafter.follow_up_cart_ig_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_ig_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_ig_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_ig_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_cart_google_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_google_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_cart_google_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_cart_google_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_fb_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_fb_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_fb_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_fb_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_line_within_seconds !== 'object') {
            const hours = Math.floor(
              parseInt(vm.wordafter.follow_up_order_line_within_seconds) / 60 / 60
            )

            let HH = '0' + (hours % 24)
            let DD = hours >= 24 ? Math.floor(hours / 24) : 0
            let mm = (
              '0' +
              JSON.stringify((parseInt(vm.wordafter.follow_up_order_line_within_seconds) / 60) % 60)
            ).slice(-2)
            if (DD > 0) {
              HH = ('0' + HH).slice(-2)
              DD = ('0' + DD).slice(-2)
              vm.wordafter.follow_up_order_line_within_seconds = { DD, HH, mm }
              vm.wordafter.follow_up_order_line_within_seconds_date = DD
            } else {
              HH = ('0' + HH).slice(-2)
              vm.wordafter.follow_up_order_line_within_seconds = { HH, mm }
            }
            if (hours >= 24) {
              vm.wordafter.follow_up_order_line_within_seconds_date = Math.floor(hours / 24)
            } else {
              vm.wordafter.follow_up_order_line_within_seconds_date = 0
            }
          }
          if (typeof vm.wordafter.follow_up_order_ig_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_ig_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_ig_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_ig_within_seconds) / 60) % 60)
              ).slice(-2)
            }
          }
          if (typeof vm.wordafter.follow_up_order_google_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_google_within_seconds = {
              HH: (
                '0' +
                Math.floor(parseInt(vm.wordafter.follow_up_order_google_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify(
                  (parseInt(vm.wordafter.follow_up_order_google_within_seconds) / 60) % 60
                )
              ).slice(-2)
            }
          }
          vm.wordafter.follow_up_cart_userstatus = response.data.follow_up_cart_userstatus
            ? response.data.follow_up_cart_userstatus
            : null
          vm.wordafter.follow_up_cart_usertags = response.data.follow_up_cart_usertags
            ? response.data.follow_up_cart_usertags
            : ''
          vm.wordafter.follow_up_order_userstatus = response.data.follow_up_order_userstatus
            ? response.data.follow_up_order_userstatus
            : null
          vm.wordafter.follow_up_order_usertags = response.data.follow_up_order_usertags
            ? response.data.follow_up_order_usertags
            : ''
        }
        vm.cached_buttons_cart_summary = JSON.stringify(vm.wordafter.buttons_cart_summary)
        vm.cached_edit_order_buttons = JSON.stringify(vm.wordafter.edit_order_buttons)
        vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
        vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)

        vm.wordafter.loading = false
      })
    },
    cancelEditWordAfterOrderAndCartSummary: function() {
      var vm = this
      vm.wordafter.buttons_cart_summary = JSON.parse(vm.cached_buttons_cart_summary)
      vm.wordafter.edit_order_buttons = JSON.parse(vm.cached_edit_order_buttons)
      vm.wordafter.wordscartsummary = JSON.parse(vm.cached_wordscartsummary)
      vm.wordafter.wordsorders = JSON.parse(vm.cached_wordsorders)
      vm.isEditOrderSummaryMessage = false
    },
    saveWordAfterOrderAndCartSummary: function() {
      var vm = this
      if (vm.showMultipleChannel) {
        //line
        if (vm.wordafter.follow_up_cart_line_within_seconds) {
          vm.wordafter.follow_up_cart_line_within_seconds.HH = vm.wordafter
            .follow_up_cart_line_within_seconds.HH
            ? vm.wordafter.follow_up_cart_line_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_line_within_seconds.mm = vm.wordafter
            .follow_up_cart_line_within_seconds.mm
            ? vm.wordafter.follow_up_cart_line_within_seconds.mm
            : '00'
          vm.wordafter.follow_up_cart_line_within_seconds.HH = `${vm.wordafter
            .follow_up_cart_line_within_seconds_date *
            24 +
            parseInt(vm.wordafter.follow_up_cart_line_within_seconds.HH)}`

          vm.wordafter.follow_up_cart_line_within_seconds.mm = vm.wordafter
            .follow_up_cart_line_within_seconds.mm
            ? vm.wordafter.follow_up_cart_line_within_seconds.mm || 0
            : '00'
        } else {
          vm.wordafter.follow_up_cart_line_within_seconds = {
            HH: `${vm.wordafter.follow_up_cart_line_within_seconds_date * 24 || 0}`,
            mm: '00'
          }
        }
        //fb
        if (vm.wordafter.follow_up_cart_fb_within_seconds) {
          vm.wordafter.follow_up_cart_fb_within_seconds.HH = vm.wordafter
            .follow_up_cart_fb_within_seconds.HH
            ? vm.wordafter.follow_up_cart_fb_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_fb_within_seconds.mm = vm.wordafter
            .follow_up_cart_fb_within_seconds.mm
            ? vm.wordafter.follow_up_cart_fb_within_seconds.mm
            : '00'
        }
        //ig
        if (vm.wordafter.follow_up_cart_ig_within_seconds) {
          vm.wordafter.follow_up_cart_ig_within_seconds.HH = vm.wordafter
            .follow_up_cart_ig_within_seconds.HH
            ? vm.wordafter.follow_up_cart_ig_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_ig_within_seconds.mm = vm.wordafter
            .follow_up_cart_ig_within_seconds.mm
            ? vm.wordafter.follow_up_cart_ig_within_seconds.mm
            : '00'
        }
        //google
        if (vm.wordafter.follow_up_cart_google_within_seconds) {
          vm.wordafter.follow_up_cart_google_within_seconds.HH = vm.wordafter
            .follow_up_cart_google_within_seconds.HH
            ? vm.wordafter.follow_up_cart_google_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_google_within_seconds.mm = vm.wordafter
            .follow_up_cart_google_within_seconds.mm
            ? vm.wordafter.follow_up_cart_google_within_seconds.mm
            : '00'
        }
      } else {
        if (vm.wordafter.follow_up_cart_within_seconds) {
          vm.wordafter.follow_up_cart_within_seconds.HH = vm.wordafter.follow_up_cart_within_seconds
            .HH
            ? vm.wordafter.follow_up_cart_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_cart_within_seconds.mm = vm.wordafter.follow_up_cart_within_seconds
            .mm
            ? vm.wordafter.follow_up_cart_within_seconds.mm
            : '00'
        }
      }

      if (vm.showMultipleChannelFollowUp) {
        //line
        if (vm.wordafter.follow_up_order_line_within_seconds) {
          vm.wordafter.follow_up_order_line_within_seconds.HH = vm.wordafter
            .follow_up_order_line_within_seconds.HH
            ? vm.wordafter.follow_up_order_line_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_line_within_seconds.mm = vm.wordafter
            .follow_up_order_line_within_seconds.mm
            ? vm.wordafter.follow_up_order_line_within_seconds.mm
            : '00'
          vm.wordafter.follow_up_order_line_within_seconds.HH = `${vm.wordafter
            .follow_up_order_line_within_seconds_date *
            24 +
            parseInt(vm.wordafter.follow_up_order_line_within_seconds.HH)}`

          vm.wordafter.follow_up_order_line_within_seconds.mm = vm.wordafter
            .follow_up_order_line_within_seconds.mm
            ? vm.wordafter.follow_up_order_line_within_seconds.mm || 0
            : '00'
        } else {
          vm.wordafter.follow_up_order_line_within_seconds = {
            HH: `${vm.wordafter.follow_up_order_line_within_seconds_date * 24 || 0}`,
            mm: '00'
          }
        }
        //fb
        if (vm.wordafter.follow_up_order_fb_within_seconds) {
          vm.wordafter.follow_up_order_fb_within_seconds.HH = vm.wordafter
            .follow_up_order_fb_within_seconds.HH
            ? vm.wordafter.follow_up_order_fb_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_fb_within_seconds.mm = vm.wordafter
            .follow_up_order_fb_within_seconds.mm
            ? vm.wordafter.follow_up_order_fb_within_seconds.mm
            : '00'
        }
        //ig
        if (vm.wordafter.follow_up_order_ig_within_seconds) {
          vm.wordafter.follow_up_order_ig_within_seconds.HH = vm.wordafter
            .follow_up_order_ig_within_seconds.HH
            ? vm.wordafter.follow_up_order_ig_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_ig_within_seconds.mm = vm.wordafter
            .follow_up_order_ig_within_seconds.mm
            ? vm.wordafter.follow_up_order_ig_within_seconds.mm
            : '00'
        }
        //google
        if (vm.wordafter.follow_up_order_google_within_seconds) {
          vm.wordafter.follow_up_order_google_within_seconds.HH = vm.wordafter
            .follow_up_order_google_within_seconds.HH
            ? vm.wordafter.follow_up_order_google_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_google_within_seconds.mm = vm.wordafter
            .follow_up_order_google_within_seconds.mm
            ? vm.wordafter.follow_up_order_google_within_seconds.mm
            : '00'
        }
      } else {
        if (vm.wordafter.follow_up_order_within_seconds) {
          vm.wordafter.follow_up_order_within_seconds.HH = vm.wordafter
            .follow_up_order_within_seconds.HH
            ? vm.wordafter.follow_up_order_within_seconds.HH
            : '00'
          vm.wordafter.follow_up_order_within_seconds.mm = vm.wordafter
            .follow_up_order_within_seconds.mm
            ? vm.wordafter.follow_up_order_within_seconds.mm
            : '00'
        }
      }
      vm.$store.dispatch('loading')
      if (vm.wordafter.buttons_cart_summary.length > 0) {
        vm.wordafter.buttons_cart_summary.map(item => {
          if (item.labels && item.id === 'BTN_CONFIRM') {
            if (item.labels['en'] === '' && vm.currentLang !== 'en') {
              item.labels['en'] = 'Confirm'
            }
            if (item.labels['la'] === '' && vm.currentLang !== 'la') {
              item.labels['la'] = 'ຢືນຢັນ'
            }
            if (item.labels['th'] === '' && vm.currentLang !== 'th') {
              item.labels['la'] = 'ยืนยันออเดอร์'
            }
          }
          if (item.labels && item.id === 'BTN_ADD') {
            if (item.labels['en'] === '' && vm.currentLang !== 'en') {
              item.labels['en'] = 'Add/Edit'
            }
            if (item.labels['la'] === '' && vm.currentLang !== 'la') {
              item.labels['la'] = 'ສັ່ງເພີ້ມ/ແກ້ໄຂ'
            }
            if (item.labels['th'] === '' && vm.currentLang !== 'th') {
              item.labels['th'] = 'เพิ่ม/แก้ไข'
            }
          }
          if (item.labels && item.id === 'BTN_EDIT') {
            if (item.labels['en'] === '' && vm.currentLang !== 'en') {
              item.labels['en'] = 'Check / Edit'
            }
            if (item.labels['la'] === '' && vm.currentLang !== 'la') {
              item.labels['la'] = 'Check / Edit'
            }
            if (item.labels['th'] === '' && vm.currentLang !== 'th') {
              item.labels['th'] = 'ตรวจสอบ / แก้ไข'
            }
          }
        })
      }
      if (vm.wordafter.edit_order_buttons.length > 0) {
        vm.wordafter.edit_order_buttons.map(item => {
          if (item.labels && item.id === 'BTN_EDIT') {
            if (item.labels['en'] === '' && vm.currentLang !== 'en') {
              item.labels['en'] = 'Check / Edit'
            }
            if (item.labels['la'] === '' && vm.currentLang !== 'la') {
              item.labels['la'] = 'Check / Edit'
            }
            if (item.labels['th'] === '' && vm.currentLang !== 'th') {
              item.labels['th'] = 'ตรวจสอบ / แก้ไข'
            }
          }
        })
      }
      let data = {
        buttons_cart_summary: JSON.stringify(vm.wordafter.buttons_cart_summary),
        edit_order_buttons: JSON.stringify(vm.wordafter.edit_order_buttons),
        wordscartsummary: JSON.stringify(vm.wordafter.wordscartsummary),
        wordsorders: JSON.stringify(vm.wordafter.wordsorders),
        pageid: vm.selectedBot.pageid,
        follow_up_cart_quick_reply: vm.wordafter.follow_up_cart_quick_reply,
        follow_up_order_quick_reply: vm.wordafter.follow_up_order_quick_reply,
        follow_up_cart_status: vm.wordafter.follow_up_cart_status,
        follow_up_order_status: vm.wordafter.follow_up_order_status,
        follow_up_cart_within_seconds: vm.wordafter.follow_up_cart_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_line_within_seconds: vm.wordafter.follow_up_cart_line_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_line_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_line_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_line_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_line_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_fb_within_seconds: vm.wordafter.follow_up_cart_fb_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_fb_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_fb_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_fb_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_fb_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_ig_within_seconds: vm.wordafter.follow_up_cart_ig_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_ig_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_ig_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_ig_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_ig_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_google_within_seconds: vm.wordafter.follow_up_cart_google_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_google_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_google_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_google_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_google_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_within_seconds: vm.wordafter.follow_up_order_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_fb_within_seconds: vm.wordafter.follow_up_order_fb_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_fb_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_fb_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_fb_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_fb_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_line_within_seconds: vm.wordafter.follow_up_order_line_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_line_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_line_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_line_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_line_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_ig_within_seconds: vm.wordafter.follow_up_order_ig_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_ig_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_ig_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_ig_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_ig_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_google_within_seconds: vm.wordafter.follow_up_order_google_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_google_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_google_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_google_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_google_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_val: JSON.stringify(vm.checkEmptyMessage(vm.messages)),
        follow_up_order_val: JSON.stringify(vm.checkEmptyMessage(vm.messages2)),
        follow_up_cart_type: 'json',
        follow_up_order_type: 'json',
        follow_up_cart_userstatus: vm.wordafter.follow_up_cart_userstatus,
        follow_up_cart_usertags: vm.wordafter.follow_up_cart_usertags,
        follow_up_order_userstatus: vm.wordafter.follow_up_order_userstatus,
        follow_up_order_usertags: vm.wordafter.follow_up_order_usertags
      }

      if (this.showMultipleChannel) {
        const filter_fb = vm.fb_messages.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_line = vm.line_messages.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_whatsapp = vm.whatsapp_messages.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_ig = vm.ig_messages.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_google = vm.google_messages.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        data.follow_up_cart_fb_val = JSON.stringify(filter_fb).replace(/ /gim, ' ')
        data.follow_up_cart_line_val = JSON.stringify(filter_line).replace(/ /gim, ' ')
        data.follow_up_cart_ig_val = JSON.stringify(filter_ig).replace(/ /gim, ' ')
        data.follow_up_cart_google_val = JSON.stringify(filter_google).replace(/ /gim, ' ')
        data.follow_up_cart_whatsapp_val = JSON.stringify(filter_whatsapp).replace(/ /gim, ' ')
        data.follow_up_cart_fb_quick_reply = vm.wordafter.follow_up_cart_fb_quick_reply
        data.follow_up_cart_line_quick_reply = vm.wordafter.follow_up_cart_line_quick_reply
        data.follow_up_cart_ig_quick_reply = vm.wordafter.follow_up_cart_ig_quick_reply
        data.follow_up_cart_google_quick_reply = vm.wordafter.follow_up_cart_google_quick_reply
        data.follow_up_cart_whatsapp_quick_reply = vm.wordafter.follow_up_cart_whatsapp_quick_reply
      }

      if (this.showMultipleChannelFollowUp) {
        const filter_fb = vm.fb_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_line = vm.line_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_whatsapp = vm.whatsapp_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_ig = vm.ig_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        const filter_google = vm.google_messages2.map(item => {
          return item.filter(msg =>
            msg.type == 'text'
              ? msg.text !== ''
              : msg.type == 'button'
              ? msg.text !== ''
              : msg.image_url !== ''
          )
        })
        data.follow_up_order_fb_val = JSON.stringify(filter_fb).replace(/ /gim, ' ')
        data.follow_up_order_line_val = JSON.stringify(filter_line).replace(/ /gim, ' ')
        data.follow_up_order_ig_val = JSON.stringify(filter_ig).replace(/ /gim, ' ')
        data.follow_up_order_google_val = JSON.stringify(filter_google).replace(/ /gim, ' ')
        data.follow_up_order_whatsapp_val = JSON.stringify(filter_whatsapp).replace(/ /gim, ' ')
        data.follow_up_order_fb_quick_reply = vm.wordafter.follow_up_order_fb_quick_reply
        data.follow_up_order_line_quick_reply = vm.wordafter.follow_up_order_line_quick_reply
        data.follow_up_order_ig_quick_reply = vm.wordafter.follow_up_order_ig_quick_reply
        data.follow_up_order_google_quick_reply = vm.wordafter.follow_up_order_google_quick_reply
        data.follow_up_order_whatsapp_quick_reply =
          vm.wordafter.follow_up_order_whatsapp_quick_reply
      }

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        // vm.wordafter.loading = true
        api.saveWordAfterOrderAndCartSummary(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            // vm.wordafter.loading = false
            return
          }
          vm.cached_buttons_cart_summary = JSON.stringify(vm.wordafter.buttons_cart_summary)
          vm.cached_edit_order_buttons = JSON.stringify(vm.wordafter.edit_order_buttons)
          vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
          vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
          // vm.wordafter.loading = false
          vm.$store.dispatch('loading')
          vm.isEditOrderSummaryMessage = false
          vm.getWordAfterOrderAndCartSummary()
        })
      })
    },
    getShopProfile: function() {
      let data = {
        pageid: this.selectedBot.pageid
      }
      let vm = this
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          vm.profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          vm.oldProfile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          var findLang = vm.langOptions.find(function(el) {
            return el.value == response.shopprofile.shoplang
          })

          if (findLang) {
            vm.lang = findLang
          } else {
            vm.lang = vm.langOptions[1]
          }

          vm.color = response.shopprofile.shopcolor ? response.shopprofile.shopcolor : '#1CA085'
        }
      })
    },
    saveProfile: function() {
      let vm = this
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.selectedBot.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid
      }
      if (vm.$store.getters.getPackage == 'premium') {
        data.shoplang = vm.profile.shoplang
        data.shopcolor = vm.color
      }

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        api.editShopProfile(data, function(error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isEditShop = false
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
        })
      })
    },

    resetPageShortLink: function() {
      if (!this.selectedBot.pageid || this.selectedBot.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.selectedBot.pageid
    },
    cancelEditProfile: function() {
      var vm = this
      this.profile.description = this.oldProfile.description
      this.profile.pageaddress = this.oldProfile.pageaddress
      this.profile.pageshortlink = this.oldProfile.pageshortlink
      var findLang = vm.langOptions.find(function(el) {
        return el.value == vm.oldProfile.shoplang
      })

      if (findLang) {
        vm.lang = findLang
      } else {
        vm.lang = vm.langOptions[1]
      }
      this.isEditShop = false
    },
    getPaypalUrl: function() {
      var vm = this
      vm.paypal.loading = true
      var data = []
      api.getPaypalUrl(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.paypal.paypal_url = response.data.links[1].href
        document.getElementById('actionId').href = vm.paypal.paypal_url + '&displayMode=minibrowser'
        vm.paypal.tracking_id = response.tracking_id
        vm.paypal.loading = false
      })
    },
    registerPaypalMerchant: function() {
      var vm = this

      document.getElementById('actionId').click()

      vm.$store.dispatch('updatePaypalTrackingId', vm.paypal.tracking_id)

      vm.paypal.haveTrackingId = true
      vm.paypal.checkTracking = true
      vm.onRefreshTrackingStatus()
    },
    cancelRegisterPaypalMerchant: function() {
      var vm = this
      if (vm.paypal.checkingInterval != null) {
        clearInterval(vm.paypal.checkingInterval)
      }
      this.getPaypalUrl()
      this.paypal.haveTrackingId = false
      this.paypal.checkTracking = false
      vm.$store.dispatch('updatePaypalTrackingId', null)
    },
    onRefreshTrackingStatus: function() {
      var vm = this
      vm.paypal.checkingTime = 6
      vm.paypal.checkTracking = true

      vm.checkingTrackingStatus(function(status) {
        if (status) {
          clearInterval(vm.paypal.checkingInterval)
          vm.paypal.checkTracking = false
        } else {
          vm.paypal.checkingInterval = setInterval(() => {
            vm.checkingTrackingStatus(function(status) {
              if (vm.paypal.checkingTime === 0 || status) {
                clearInterval(vm.paypal.checkingInterval)
                vm.paypal.checkTracking = false
              }
              vm.paypal.checkingTime--
            })
          }, vm.paypal.checkingTimePerInterval)
        }
      })
    },
    checkingTrackingStatus: function(callback) {
      var vm = this
      var data = {
        tracking_id: vm.paypalTrackingId
      }
      api.getPaypalTrackingStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        if (response.status === 'pending') {
          callback(false)
        } else if (
          response.status === 'success' &&
          response.merchant_id !== '' &&
          response.merchant_id != null
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            paypal_merchantid: response.merchant_id
          }
          api.updatePaypalMerchantId(data, function(error, response) {
            if (error) {
              console.error(error)
              return
            }
            vm.contents.allowcreditcard.contentvalue = true

            vm.$store.dispatch('updateMerchantId', data.paypal_merchantid)

            callback(true)
          })
        }
      })
    },
    async getUserTagList() {
      await this.$store.dispatch('loadTags')
      if (this.userTagItems.length > 0) {
        this.tagOptions = this.userTagItems.map(item => {
          return item.name || ''
        })
      }
    },
    async getUserStatusList() {
      await this.$store.dispatch('loadStatus')
      if (this.userStatus.length > 0) {
        this.statusOptions = this.userStatus.map(item => {
          return item.name
        })
      }
    },
    addUserCartTags(newTags) {
      this.wordafter.follow_up_cart_usertags =
        newTags && newTags.length ? newTags.map(tag => tag.text).join(',') : ''
    },
    checkUserCartTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 25) {
        this.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addUserOrderTags(newTags) {
      this.wordafter.follow_up_order_usertags =
        newTags && newTags.length ? newTags.map(tag => tag.text).join(',') : ''
    },
    checkUserOrderTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 25) {
        this.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onSelectCartStatus(value) {
      if (value.length <= 25) {
        this.errorMaxlength = false
        this.wordafter.follow_up_cart_userstatus = value
      } else {
        this.errorMaxlength = true
      }
    },
    onSelectOrderStatus(value) {
      if (value.length <= 25) {
        this.errorMaxlength = false
        this.wordafter.follow_up_order_userstatus = value
      } else {
        this.errorMaxlength = true
      }
    },
    openLink(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
@media only screen and (max-width: 600px) {
  .shopOption {
    margin-top: 18px !important;
  }
  .lineFollowupText {
    max-width: 80px !important;
  }
}

.form-inline {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/paymentSetting.vue